import { Types } from '../../../../../actions/dashboards'
import { Metrics } from '../../../../../constants/Dashboards'
import buildAsyncStatReducer from './../../asyncStatReducer'
import { PlaylistInteractions } from '../../types'

/**
 * WFH Interactions Per Playlist reducer
 */
const wfhInteractionsPerPlaylist = buildAsyncStatReducer({
    key: Metrics.WFH_INTERACTIONS_PLAYLISTS,
    types: {
        request: Types.DASHBOARD_WFH_INTERACTIONS_PLAYLIST.request,
        success: Types.DASHBOARD_WFH_INTERACTIONS_PLAYLIST.success,
        failure: Types.DASHBOARD_WFH_INTERACTIONS_PLAYLIST.failure,
    },
    transform: (state, { payload }): PlaylistInteractions[] => payload,
})

export default wfhInteractionsPerPlaylist
